module.exports = {
  language: '言語',
  selectLanguage: '言語を選択',
  charging: '充電中',
  notCharging: '充電していません',
  advanceSetting: '詳細設定',
  chargingDesc: 'バッテリーレベルが次より低くなったときに充電を開始します ',
  enabled: '有効',
  disabled: '無効',
  onPowerRestore: '電源復旧時',
  powerWakeDesc: '** RaspberryPiとPiSugarをそれぞれ独立したUSB充電器で充電し、PiSugarの電源スイッチをオンにしてください。外部電源が復旧すると自動的に電源が入ります。',
  powerWakeDescFor3: 'PiSugarは外部電源が復旧すると自動的に電源が入ります。',
  powerWakeOffWarning: '電源復旧時の起動機能を無効にしました。Raspberry Piに個別に外部電源を供給しないでください。',
  powerWakeOffTitle: '注意',
  confirmButtonText: '確認',
  wakeUpFeature: 'スケジュール起動',
  repeat: '繰り返し',
  repeatEveryday: '毎日繰り返し',
  repeatOn: '指定日に繰り返し',
  checkAll: 'すべて選択',
  clearAll: 'すべて解除',
  wakeUpDesc: 'スケジュール起動時刻',
  wakeUpOffDesc: 'スケジュール起動無効',
  buttonFunction: 'カスタムボタン機能',
  singleTapLabel: 'シングルタップ',
  doubleTapLabel: 'ダブルタップ',
  longTapLabel: 'ロングタップ',
  singleTap: 'シングルタップ',
  doubleTap: 'ダブルタップ',
  longTap: 'ロングタップ',
  none: 'なし',
  edit: '編集',
  customShell: 'カスタムシェル',
  shutdown: 'シャットダウン',
  shellModalTitle: {
    single: 'シングルタップ実行用シェル',
    double: 'ダブルタップ実行用シェル',
    long: 'ロングタップ実行用シェル'
  },
  shell: 'シェル',
  shellPlaceholder: 'シェルスクリプトを入力してください...',
  cancel: 'キャンセル',
  confirm: '確認',
  triggered: 'トリガー',
  safeShutdown: '安全なシャットダウン',
  batteryLevel: 'バッテリーレベル',
  immediately: '即座に',
  secondsDelay: '秒遅延',
  rtcTime: 'RTC時刻',
  sysTime: 'システム時刻',
  syncTime: '時刻同期',
  weekDay: {
    Monday: '月曜日',
    Tuesday: '火曜日',
    Wednesday: '水曜日',
    Thursday: '木曜日',
    Friday: '金曜日',
    Saturday: '土曜日',
    Sunday: '日曜日'
  },
  weekDayShort: {
    Mon: '月',
    Tue: '火',
    Wed: '水',
    Thu: '木',
    Fri: '金',
    Sat: '土',
    Sun: '日'
  },
  batteryInputProtect: 'バッテリー入力保護',
  batteryInputProtectDesc: 'バッテリーが60%〜80%に達すると充電プロセスが停止し、バッテリー寿命を効果的に延ばすことができます。',
  antiMistouch: '誤操作防止',
  antiMistouchDesc: '誤操作防止が有効になっている場合、スイッチをクリックして長押しする必要があります。',
  softPoweroff: 'ソフトシャットダウン',
  softPoweroffDesc: 'スイッチボタンを使用してシャットダウンしても直接電源が切れず、ソフトウェアからシャットダウンコマンドが発行されます。',
  softPoweroffShell: 'ソフトシャットダウンシェル',
  softPoweroffShellDesc: 'ソフトシャットダウンイベントがトリガーされた時に実行するシェル',
  changeLoginPassword: 'ログインパスワード変更',
  username: 'ユーザー名',
  password: 'パスワード',
  passwordConfirm: 'パスワードを再入力してください',
  usernameCannotBeEmpty: 'ユーザー名を入力してください',
  passwordCannotBeEmpty: 'パスワードを入力してください',
  passwordNotConsistent: '2つのパスワードが一致しません',
  usernameWithSpace: 'ユーザー名にスペースを含めることはできません',
  passwordWithSpace: 'パスワードにスペースを含めることはできません',
  changePasswordSuccess: '変更が完了しました。',
  loginDialog: 'ログイン',
  login: 'ログイン'
}



// WEBPACK FOOTER //
// ./src/locale/ja-JP.js